var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveCardIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8169 4.52926L2.31588 18.7211C2.1406 19.0246 2.04786 19.3688 2.04688 19.7193C2.0459 20.0698 2.13671 20.4144 2.31028 20.7189C2.48385 21.0235 2.73413 21.2772 3.03622 21.455C3.3383 21.6327 3.68167 21.7283 4.03215 21.7321H21.0343C21.3848 21.7283 21.7281 21.6327 22.0302 21.455C22.3323 21.2772 22.5826 21.0235 22.7561 20.7189C22.9297 20.4144 23.0205 20.0698 23.0195 19.7193C23.0186 19.3688 22.9258 19.0246 22.7505 18.7211L14.2495 4.52926C14.0706 4.23429 13.8186 3.99041 13.518 3.82116C13.2174 3.65191 12.8782 3.56299 12.5332 3.56299C12.1882 3.56299 11.849 3.65191 11.5484 3.82116C11.2478 3.99041 10.9959 4.23429 10.8169 4.52926Z",
    fill: "url(#paint0_linear_1197_13271)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5352 9.68811V13.7028",
    stroke: "#ED4141",
    strokeWidth: 1.40513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5352 17.7174H12.5452",
    stroke: "#ED4141",
    strokeWidth: 1.40513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_13271",
    x1: 8.51975,
    y1: 6.17532,
    x2: 21.0656,
    y2: 22.7358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA217"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveCardIcon4);
export default __webpack_public_path__ + "static/media/drive_card_icon4.2741319341f9c5588d391578f9af69a1.svg";
export { ForwardRef as ReactComponent };